<ctw-journey-planner-print
    [cacheKey]="cacheKey"
    [tripIndex]="tripIndex"
    (raisedEvent)="raisedEvent($event)"
>
</ctw-journey-planner-print>